import { IntegrationService } from '../../../../../../services/exports/Constants';

export default {
  title: 'Integrări',
  services: {
    [IntegrationService.Tabless]: 'Tabless',
    [IntegrationService.WinOrder]: 'WinOrder',
    [IntegrationService.ExpertOrder]: 'ExpertOrder',
    [IntegrationService.Deliverect]: 'Deliverect',
    [IntegrationService.Liefersoft]: 'Liefersoft',
    [IntegrationService.Hubrise]: 'HubRise',
  },
  labels: {
    no_integrations: '{{company}} nu are integrări configurate.',
  },
  buttons: {
    add_integration: 'Adăugați integrare',
  },
  toasts: {
    error: 'Salvarea modificărilor a eșuat',
    success: 'Modificările au fost salvate',
    load_error: 'Încărcarea integrărilor a eșuat',
  },
};
